// Collect a full list without exceeding the API's maximum page size.
export async function fetchAllPages(fetchPage, key, params = {}) {
  const items = [];
  let page = 1;
  while (true) {
    const response = await fetchPage({ ...params, page, limit: 100 });
    const data = response.data;
    if (!Array.isArray(data?.[key]) || typeof data.pagination?.hasNext !== 'boolean') {
      throw new Error(`Invalid ${key} response`);
    }
    items.push(...data[key]);
    if (!data.pagination.hasNext) {
      return { ...response, data: { [key]: items } };
    }
    if (data[key].length === 0) {
      throw new Error(`Empty page while loading ${key}`);
    }
    page += 1;
  }
}

// The public Bible catalog does not change during an app session. Share both
// in-flight and completed requests across pages, but allow retries after errors.
export function cacheSuccessfulRequest(fetchData) {
  let request;
  return () => {
    if (!request) {
      request = Promise.resolve().then(fetchData).catch(error => {
        request = undefined;
        throw error;
      });
    }
    return request;
  };
}
